// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CallLimitsParticipantsToast__event-b67d09 {
  display: inline-flex;
  border-radius: 12px;
  box-sizing: border-box;
  padding: 6px 12px;
  align-items: center;
  background-color: var(--addition-110_70);
  z-index: 5;
  min-width: 400px;
  justify-content: center;
  cursor: pointer;
  margin-bottom: 16px;
}

.CallLimitsParticipantsToast__second-ea61b2 {
  top: 62px;
}

.CallLimitsParticipantsToast__event-text-a987a2 {
  word-break: break-word;
  font: var(--font-subtitle-3);
  letter-spacing: var(--font-spacing-subtitle-3);
  color: var(--addition-50);
}

.CallLimitsParticipantsToast__enter-c8ca0e {
  opacity: 0;
  margin-top: -30px;
}

.CallLimitsParticipantsToast__enter-active-ed92a0 {
  opacity: 1;
  margin-top: 0;
  transition: opacity 250ms linear, margin-top 250ms linear;
}

.CallLimitsParticipantsToast__exit-abd06e {
  opacity: 1;
}

.CallLimitsParticipantsToast__exit-active-e6561a {
  opacity: 0;
  transition: opacity 250ms linear;
}`, "",{"version":3,"sources":["webpack://./../../packages/call/src/CallView/FullScreenCallView/Shared/CallLimitsParticipantsToast/CallLimitsParticipantsToast.styles.m.css"],"names":[],"mappings":"AAAA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iBAAA;EACA,mBAAA;EACA,wCAAA;EACA,UAAA;EACA,gBAAA;EACA,uBAAA;EACA,eAAA;EACA,mBAAA;AACF;;AAEA;EACE,SAAA;AACF;;AAEA;EACE,sBAAA;EACA,4BAAA;EACA,8CAAA;EACA,yBAAA;AACF;;AAEA;EACE,UAAA;EACA,iBAAA;AACF;;AAEA;EACE,UAAA;EACA,aAAA;EACA,yDAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,UAAA;EACA,gCAAA;AACF","sourcesContent":[".event {\n  display: inline-flex;\n  border-radius: 12px;\n  box-sizing: border-box;\n  padding: 6px 12px;\n  align-items: center;\n  background-color: var(--addition-110_70);\n  z-index: 5;\n  min-width: 400px;\n  justify-content: center;\n  cursor: pointer;\n  margin-bottom: 16px;\n}\n\n.second {\n  top: 62px;\n}\n\n.event-text {\n  word-break: break-word;\n  font: var(--font-subtitle-3);\n  letter-spacing: var(--font-spacing-subtitle-3);\n  color: var(--addition-50);\n}\n\n.enter {\n  opacity: 0;\n  margin-top: -30px;\n}\n\n.enter-active {\n  opacity: 1;\n  margin-top: 0;\n  transition: opacity 250ms linear, margin-top 250ms linear;\n}\n\n.exit {\n  opacity: 1;\n}\n\n.exit-active {\n  opacity: 0;\n  transition: opacity 250ms linear;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"event": `CallLimitsParticipantsToast__event-b67d09`,
	"second": `CallLimitsParticipantsToast__second-ea61b2`,
	"event-text": `CallLimitsParticipantsToast__event-text-a987a2`,
	"eventText": `CallLimitsParticipantsToast__event-text-a987a2`,
	"enter": `CallLimitsParticipantsToast__enter-c8ca0e`,
	"enter-active": `CallLimitsParticipantsToast__enter-active-ed92a0`,
	"enterActive": `CallLimitsParticipantsToast__enter-active-ed92a0`,
	"exit": `CallLimitsParticipantsToast__exit-abd06e`,
	"exit-active": `CallLimitsParticipantsToast__exit-active-e6561a`,
	"exitActive": `CallLimitsParticipantsToast__exit-active-e6561a`
};
module.exports = ___CSS_LOADER_EXPORT___;
